const AgentsSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_5308_615)">
        <path
          d="M2.625 4.125V7.125M4.845 6C4.75301 5.44227 4.45445 4.9396 4.00872 4.59197C3.56299 4.24434 3.00273 4.07722 2.43939 4.12385C1.87605 4.17048 1.3509 4.42744 0.968394 4.84363C0.585884 5.25982 0.374043 5.80473 0.375003 6.37V7.87H1.125L1.5 11.625H3.75L4.125 7.875M5.625 9H11.625M8.625 9V10M7.5 7.125V6.5C7.5 6.20163 7.61853 5.91548 7.82951 5.7045C8.04049 5.49353 8.32663 5.375 8.625 5.375C8.92337 5.375 9.20952 5.49353 9.4205 5.7045C9.63148 5.91548 9.75 6.20163 9.75 6.5V7.125M1.125 1.875C1.125 2.27282 1.28304 2.65436 1.56434 2.93566C1.84565 3.21696 2.22718 3.375 2.625 3.375C3.02283 3.375 3.40436 3.21696 3.68566 2.93566C3.96697 2.65436 4.125 2.27282 4.125 1.875C4.125 1.47718 3.96697 1.09564 3.68566 0.81434C3.40436 0.533035 3.02283 0.375 2.625 0.375C2.22718 0.375 1.84565 0.533035 1.56434 0.81434C1.28304 1.09564 1.125 1.47718 1.125 1.875ZM6.125 7.125H11.125C11.125 7.125 11.625 7.125 11.625 7.625V11.125C11.625 11.125 11.625 11.625 11.125 11.625H6.125C6.125 11.625 5.625 11.625 5.625 11.125V7.625C5.625 7.625 5.625 7.125 6.125 7.125Z"
          stroke="#333333"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5308_615">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AgentsSvg;
